<template>
  <div id="app" style="display: flex; flex-direction: column;height:100vh;">
    <div style="flex:1">
      <img class="img_logo" alt="" src="./assets/logo.png" />
      <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
      <Home msg="Welcome to Your Vue.js App" />
    </div>
    <footer class="footer">
      <img class="img_bei" alt="" src="./assets/bei.png" />
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=36010802001072" rel="noreferrer" target="_blank">赣公网安备  36010802001072</a>
      <a style="margin-left:20px;" href="https://beian.miit.gov.cn/" target="_blank">赣ICP备 2024042037号-1</a>
    </footer>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import Home from "./components/Home.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
    Home,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.img_logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.img_bei {
  width:14px;
  margin-right:10px;
}
@media (max-width: 600px) {
  .img_logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
}
.footer {
  text-align: center;
  padding: 2px;
  background-color: #f8f9fa;
  color: #6c757d;
  font-size: 14px;
  border-top: 1px solid #e9ecef;
}
</style>
